import __dataMark from './dataMark';

export default __dataMark;
